import { getProductById } from '../../api/subscribe-bis';
import { setSessionStorage } from '../../utils/browser';
import { getVariantIdFromUrl } from '../events/variant-events';

/**
 * @type {import('../index.d').fetchProductData}
 */
export const fetchProductData = async (context, productId) => {
  try {
    const product = await getProductById(context, productId);
    if (!product) return null;
    return product;
  } catch (error) {
    console.error('Error fetching product data:', error);
    return null;
  }
};

/**
 * @type {import('../index.d').initialVariant}
 */
export const initialVariant = async (context) => {
  const productId = window.boostSDData?.product?.id;
  if (!productId) return null;

  const product = await fetchProductData(context, productId);
  if (!product || !product.variants) return null;

  const variants = product.variants;
  const variantId = getVariantIdFromUrl();

  setSessionStorage('preVariantIdSelected', variantId);

  return variantId
    ? variants.find((variant) => String(variant?.id) === String(variantId))
    : variants.find((variant) => variant?.available);
};
